import * as Utility from './utility.models';

export interface IPartModel {
  id: string;
  quantity: number;
  unit: string;
  cost: number;
  description: string;
  sortOrder: number;
  timestamp: Date;
}

export class PartModel implements IPartModel {
  id: string = null;
  quantity: number = null;
  unit: string = null;
  cost: number = null;
  description: string = null;
  sortOrder: number;
  timestamp: Date = null;
}

export interface INonContractPartModel {
  sortOrder: number;
  quantity: number;
  unit: string;
  description: string;
  cost: number;
}

export class NonContractPartModel implements INonContractPartModel {
  sortOrder: number = null;
  quantity: number = null;
  unit: string = null;
  description: string = null;
  cost: number = null;

  constructor(index: number, pipeArray: string) {
    let s = pipeArray.split('|');
    this.sortOrder = index;
    this.quantity = Number.parseFloat(s[0]);
    this.unit = s[1];
    this.description = s[2];
    this.cost = Number.parseFloat(s[3]);
  }
}

export interface IPartConnection {
  partIds: Array<string>;
}
